import General from './apis/General'
import Map from './apis/Map'
import Dem from './apis/Dem'
import Coordinate from './apis/Coordinate'
export default {
	General,
	Map,
	Dem,
	Coordinate
}
